export default __webpack_public_path__ + "static/media/flow.d21a0335.svg";